<template>
    <v-container grid-list-sm>
        <v-layout row wrap v-show="!selectedCustomer._id && selectedPriceList.Group === 'C.R.P.'">
            <v-flex xs12>
                <v-alert :value="true" type="info" outline>
                    <div @click.stop="">
                        Please <a href="javascript:;" @click.stop="gotoCustomers">select a customer</a> to view the pricelist.
                    </div>
                </v-alert>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-show="!(!selectedCustomer._id && selectedPriceList.Group === 'C.R.P.')">
            <v-flex xs12>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs8 v-show="selectedPriceList.Group === 'C.R.P.'">
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light pt-3 pl-1"><span class="primary--text f-b">{{ selectedCustomer.SN_ACCOUNT }}</span> {{ selectedCustomer.SN_NAME }}</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs4 v-show="selectedPriceList.Group === 'C.R.P.'">
                            <v-layout align-center justify-end row fill-height>
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 v-show="selectedPriceList.Group !== 'C.R.P.'">
                            <v-toolbar class="elevation-1" color="primary" dense flat dark>
                                <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                                <v-menu open-on-hover bottom offset-y v-for="item in priceListOptions" :key="item._id">
                                    <template v-slot:activator="{ on }">
                                        <span class="subheading mr-3" v-on="on">
                                            <span>{{ item.Name }}</span>
                                            <v-icon>arrow_drop_down</v-icon>
                                        </span>
                                    </template>
                                    <v-list>
                                        <v-list-tile v-for="sub in item.Items" :key="sub._id" @click="onMenuSelect(sub)">
                                            <v-list-tile-title v-text="sub.Name"></v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <v-spacer></v-spacer>
                                <!-- <v-btn icon>
                                    <v-icon>edit</v-icon>
                                </v-btn> -->
                            </v-toolbar>
                        </v-flex>
                        <!-- <v-flex xs12 v-show="selectedPriceList !== 'C.R.P.'">
                            <v-btn-toggle v-model="selectedPriceList" mandatory @change="loadData">
                                <v-btn v-for="item in priceListOptions" :key="item" flat :value="item">{{ item }}</v-btn>
                            </v-btn-toggle>
                        </v-flex> -->
                        <v-flex xs7>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">{{ selectedPriceList.Group }} Price List ({{ $format.int(tableData.length) }})</h1>
                                <v-tooltip right>
                                    <template>
                                        <v-btn slot="activator" flat icon color="accent" class="mt-2" @click="onItemAdd"><v-icon>add_circle</v-icon></v-btn>
                                    </template>
                                    <span>Import price list from Excel file</span>
                                </v-tooltip>
                            </v-layout>
                        </v-flex>
                        <v-flex xs5>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter the list" :hint="`(${searchAt.text}) Description, Unit, Comment`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 v-show="selectedPriceList.Group !== 'C.R.P.'">
                            <h1 class="subheading">{{ selectedPriceList.Name || '(Select a price list item from the menu above)' }}</h1>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-alert v-if="priceData.Note" :value="true" type="info" color="accent">{{ priceData.Note }}</v-alert>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left pt-3">
                                        <span class="subheading ml-3">Published Date:<b class="ml-3">{{ $format.dateShort(priceData.Dt) }}</b></span>
                                    </div>
                                    <div class="pt-2 pb-1 el-float-right">
                                        <v-btn color="primary" @click="onQuote" :disabled="!selected.length">Quote Selected</v-btn>
                                    </div>
                                </div>
                                <v-divider></v-divider>
                                <v-data-table v-model="selected" :headers="headers" :items="tableData" :loading="isBusy" item-key="_id" hide-actions v-if="!isTwoPrice">
                                    <template slot="items" slot-scope="props">
                                        <tr :active="props.selected" @click="props.selected = !props.selected">
                                            <td><v-checkbox :input-value="props.selected" primary hide-details></v-checkbox></td>
                                            <!-- <td>{{ props.item.Item }}</td> -->
                                            <td>{{ props.item.Desc }}</td>
                                            <td>{{ props.item.Unit }}</td>
                                            <td class="text-xs-right">{{ $format.currency(props.item.Price) }}</td>
                                            <td>
                                                <div>{{ props.item.Comm }}</div>
                                                <div class="f-m opa-6">{{ props.item.Add }}</div>
                                            </td>
                                            <!-- <td>{{ props.item.Jmp }}</td>
                                            <td>{{ props.item.Opera }}</td>
                                            <td>{{ props.item.Add }}</td> -->
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-data-table v-model="selected" :headers="headers2" :items="tableData" :loading="isBusy" item-key="_id" hide-actions v-if="isTwoPrice">
                                    <template slot="items" slot-scope="props">
                                        <tr :active="props.selected" @click="onMultiPriceRow(props)">
                                            <!-- <td><v-checkbox :input-value="props.selected" primary hide-details></v-checkbox></td> -->
                                            <!-- <td>{{ props.item.Item }}</td> -->
                                            <td>{{ props.item.Desc }}</td>
                                            <td>{{ props.item.Unit }}</td>
                                            <td class="text-xs-right">
                                                <v-checkbox v-model="props.item.SelP1" hide-details class="chk-selector"></v-checkbox>
                                            </td>
                                            <td :class="`PR${props.item.SelP1 ? ' f-b blue-grey lighten-4' : ''}`">{{ $format.currency(props.item.Price) }}</td>
                                            <td class="text-xs-right">
                                                <v-checkbox v-model="props.item.SelP2" hide-details class="chk-selector"></v-checkbox>
                                            </td>
                                            <td :class="`PR${props.item.SelP2 ? ' f-b blue-grey lighten-4' : ''}`">{{ $format.currency(props.item.Price2) }}</td>
                                            <!-- <td class="text-xs-right">{{ $format.currency(props.item.Price) }}</td>
                                            <td class="text-xs-right" v-if="props.item.Price2 !== undefined">{{ $format.currency(props.item.Price2) }}</td> -->
                                            <td>
                                                <div>{{ props.item.Comm }}</div>
                                                <div class="f-m opa-6">{{ props.item.Add }}</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-right">
                                        <v-btn color="primary" @click="onQuote" :disabled="!selected.length">Quote Selected</v-btn>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Constants from '../../util/Constants';
import Data from '../../util/Data';
import Util from '../../util/Util';

export default {
    name: 'PriceList',
    props: {},
    data() {
        return {
            title: 'Price List',
            user: { has: () => 0 },
            ViewCompany: {},
            selectedCustomer: {},
            selectedPriceList: {},
            searchText: '',
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            item: {},
            isTwoPrice: false,
            selected: [],
            headers: [
                { text: '', value: 'selected', align: 'left', width: '80px', sortable: false },
                { text: 'Description', value: 'Desc', align: 'left', sortable: false },
                { text: 'Unit', value: 'Unit', align: 'left', width: '80px', sortable: false },
                { text: 'Price', value: 'Price', align: 'right', width: '120px', sortable: false },
                { text: 'Comment', value: 'Comm', align: 'left', sortable: false },
                /* { text: 'Jmp', value: 'Jmp', align: 'left', width: '110px', sortable: false },
                { text: 'Opera', value: 'Opera', align: 'left', width: '110px', sortable: false },
                { text: 'Add', value: 'Add', align: 'left', width: '110px', sortable: false }, */
            ],
            headers2: [
                /* { text: '', value: 'selected', align: 'left', width: '80px', sortable: false }, */
                { text: 'Description', value: 'Desc', align: 'left', sortable: false },
                { text: 'Unit', value: 'Unit', align: 'left', width: '80px', sortable: false },
                { text: '', value: 'SelP1', align: 'right', sortable: false, width: '30px' },
                { text: 'Price', value: 'Price', align: 'right', width: '120px', sortable: false },
                { text: '', value: 'SelP2', align: 'right', sortable: false, width: '30px' },
                { text: 'Price 2', value: 'Price2', align: 'right', width: '120px', sortable: false },
                { text: 'Comment', value: 'Comm', align: 'left', sortable: false },
            ],
            isBusy: false,
            isDialogBusy: false,
            tableData: [],
            priceData: {},
            priceListOptions: [],
            // standardOptions: ['Rubber', 'Sponge', 'I.G.M.', 'Metal', 'Mining', 'Other'],
            standardOptions: [],
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.searchText = '';
            this.loadData();
        });
        this.$root.$on('PriceSwitch', switchTo => {
            // The switch happens between STD and CRP price list and vice versa.
            if (switchTo === 'CRP') {
                // this.priceListOptions = this.crpOptions;
                this.selectedPriceList = { Group: 'C.R.P.' };
            }
            else {
                this.priceListOptions = this.standardOptions;
                // this.selectedPriceList = 'Rubber';
                this.selectedPriceList = {};
            }
            this.item = {};
            this.searchText = '';
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.searchAt = this.searchAtOptions[2];
        this.loadMenu();
        this.selectedCustomer = this.ContextCustomer;
        if (this.$router.currentRoute.name === 'CRP') {
            // this.priceListOptions = this.crpOptions;
            this.selectedPriceList = { Group: 'C.R.P.' };
        }
        else {
            this.priceListOptions = this.standardOptions;
            // this.selectedPriceList = 'Rubber';
            this.selectedPriceList = {};
        }
        this.loadData();
    },
    methods: {
        async loadMenu() {
            try {
                // this.isBusy = true;
                // const response = await this.$cache.dataPost('jmp_stdmenu', '/PriceList/standard-menu', { C_Id: this.ViewCompany._id });
                const response = await this.$http.post('/PriceList/standard-menu', { C_Id: this.ViewCompany._id });
                this.standardOptions = response.data.d;
                this.standardOptions.forEach(m => {
                    m.Items.forEach(o => {
                        o.Group = m.Name;
                    });
                });
                this.priceListOptions = this.standardOptions;
                // this.isBusy = false;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
        },
        async loadData() {
            try {
                this.isBusy = true;
                const response = await this.$http.post('/PriceList/list', { C_Id: this.ViewCompany._id, CU_Id: this.selectedCustomer._id, Group: this.selectedPriceList.Group, Type: this.selectedPriceList._id });
                this.priceData = response.data.d.length ? response.data.d[0] : { P: [] };
                if (this.priceData.Meta) {
                    this.isTwoPrice = this.priceData.Meta.Price2 !== undefined;
                    const hp1 = this.headers2.find(o => o.value === 'Price');
                    hp1.text = this.priceData.Meta.PriceTitle || 'Price';
                }
                if (this.isTwoPrice) {
                    const hp2 = this.headers2.find(o => o.value === 'Price2');
                    hp2.text = this.priceData.Meta.Price2Title || 'Price 2';
                }
                if (this.searchText) this.doFilter();
                else this.tableData = this.priceData.P;
                if (this.$refs.search) setTimeout(() => this.$refs.search.focus(), 250);
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) this.loadData();
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.filterTimer);
            this.filterTimer = setTimeout(this.doFilter.bind(this), 400);
        },
        doFilter() {
            this.searchText = this.searchText || '';
            if (!this.searchText) {
                this.tableData = this.priceData.P;
                return;
            }
            this.tableData = Util.searchFilterAt(this.searchText, ['Desc', 'Unit', 'Comm'], this.priceData.P, this.searchAt.value);
        },
        onSortChange(args) {
            if (!args.order) this.sortField = null;
            else {
                this.sortField = {};
                this.sortField[args.prop] = args.order === 'ascending' ? 1 : -1;
            }
            this.loadData();
        },
        gotoCustomers() {
            this.$router.push({ name: 'Customers' });
        },
        onItemAdd() {
            this.$router.push({ name: 'PriceListImport', query: { selectedPriceList: this.selectedPriceList } });
        },
        onMultiPriceRow(props) {
            props.selected = props.item.SelP1 || props.item.SelP2;
        },
        onQuote() {
            let records = [];
            if (this.isTwoPrice) {
                // The grid acts a bit funny in this scenario. this.selected will have multiple entries for the same record is it was toggled (checkbox) a couple of times.
                // The all reflect the same record values though.
                const uniq = [];
                this.selected.forEach(o => {
                    if (uniq.indexOf(o.Item) === -1) {
                        uniq.push(o.Item);
                        if (o.SelP1) {
                            const p1 = Data.duplicate(o);
                            delete p1.Price2;
                            delete p1.SelP1;
                            delete p1.SelP2;
                            records.push(p1);
                        }
                        if (o.SelP2) {
                            const p2 = Data.duplicate(o);
                            p2.Price = p2.Price2;
                            delete p2.Price2;
                            delete p2.SelP1;
                            delete p2.SelP2;
                            records.push(p2);
                        }
                    }
                });
            }
            else {
                records = this.selected;
            }
            this.$router.push({ name: 'QuoteSession', query: { product: { type: (this.selectedPriceList.Group === 'C.R.P.' ? 'CRP' : 'STD'), data: records } } });
        },
        onMenuSelect(item) {
            this.selectedPriceList = item;
            this.searchText = '';
            this.loadData();
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/PriceList/PriceList.vue